// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Testimonial_Testimonial__yq7mr .Testimonial_cardContainer__5NWoC {
  display: flex;
  margin: 20px 0;
  gap: 1rem;
}
.Testimonial_Testimonial__yq7mr .Testimonial_cardContainer__5NWoC .Testimonial_card__YkUOl {
  min-height: 250px;
  width: 30%;
  border: 1px solid #e3ebf2;
  padding: 20px;
  border-radius: 15px;
  background-color: #ffbc51;
  color: #212121;
}
.Testimonial_Testimonial__yq7mr .Testimonial_cardContainer__5NWoC .Testimonial_card__YkUOl p {
  font-size: 1rem;
  line-height: 25px;
  margin-bottom: 30px;
}
.Testimonial_Testimonial__yq7mr .Testimonial_cardContainer__5NWoC .Testimonial_card__YkUOl .Testimonial_cardFooterContent__z5Hb8 {
  margin: 0;
  padding: 0;
}
.Testimonial_Testimonial__yq7mr .Testimonial_cardContainer__5NWoC .Testimonial_card__YkUOl .Testimonial_cardFooterContent__z5Hb8 h4 {
  margin: 0;
  font-size: 14px;
}
.Testimonial_Testimonial__yq7mr .Testimonial_cardContainer__5NWoC .Testimonial_card__YkUOl .Testimonial_cardFooterContent__z5Hb8 span {
  font-size: 14px;
}
.Testimonial_Testimonial__yq7mr .Testimonial_Footer__Phhvp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row-reverse;
}
.Testimonial_Testimonial__yq7mr .Testimonial_Footer__Phhvp .Testimonial_bulletContainer__5wibV {
  column-gap: 0.5rem;
  display: flex;
}
.Testimonial_Testimonial__yq7mr .Testimonial_Footer__Phhvp .Testimonial_bulletContainer__5wibV .Testimonial_bullet__XQ\\+9u {
  height: 15px;
  width: 15px;
  background-color: #e3ebf2;
  border-radius: 30px;
}
.Testimonial_Testimonial__yq7mr .Testimonial_Footer__Phhvp .Testimonial_bulletContainer__5wibV .Testimonial_bullet__XQ\\+9u.Testimonial_active__blcgg {
  background-color: #015d8e;
}
.Testimonial_Testimonial__yq7mr .Testimonial_Footer__Phhvp .Testimonial_arrowContainer__5Kmi9 {
  display: flex;
  gap: 1rem;
  margin: 20px 0;
}
.Testimonial_Testimonial__yq7mr .Testimonial_Footer__Phhvp .Testimonial_arrowContainer__5Kmi9 .Testimonial_arrowBtn__p3scp {
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e3ebf2;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.5s ease-in-out;
}
.Testimonial_Testimonial__yq7mr .Testimonial_Footer__Phhvp .Testimonial_arrowContainer__5Kmi9 .Testimonial_arrowBtn__p3scp:hover {
  background-color: #015d8e;
  border: 1px solid transparent;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/Testimonial/Testimonial.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,cAAA;EACA,SAAA;AAFJ;AAII;EACE,iBAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBCZU;EDaV,cCRQ;ADMd;AAIM;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAFR;AAKM;EACE,SAAA;EACA,UAAA;AAHR;AAKQ;EACE,SAAA;EACA,eAAA;AAHV;AAMQ;EACE,eAAA;AAJV;AAUE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;AARJ;AAUI;EACE,kBAAA;EACA,aAAA;AARN;AAUM;EACE,YAAA;EACA,WAAA;EACA,yBC3CY;ED4CZ,mBAAA;AARR;AAUQ;EACE,yBCpDQ;AD4ClB;AAaI;EACE,aAAA;EACA,SAAA;EACA,cAAA;AAXN;AAaM;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAXR;AAaQ;EACE,yBC1EQ;ED2ER,6BAAA;EACA,cC1EI;AD+Dd","sourcesContent":["@import '../../variables';\n\n.Testimonial {\n  .cardContainer {\n    display: flex;\n    margin: 20px 0;\n    gap: 1rem;\n\n    .card {\n      min-height: 250px;\n      width: 30%;\n      border: 1px solid $card-border-color;\n      padding: 20px;\n      border-radius: 15px;\n      background-color: $primary-color;\n      color: $black-color;\n\n      p {\n        font-size: 1rem;\n        line-height: 25px;\n        margin-bottom: 30px;\n      }\n\n      .cardFooterContent {\n        margin: 0;\n        padding: 0;\n\n        h4 {\n          margin: 0;\n          font-size: 14px;\n        }\n\n        span {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  .Footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row-reverse;\n\n    .bulletContainer {\n      column-gap: 0.5rem;\n      display: flex;\n\n      .bullet {\n        height: 15px;\n        width: 15px;\n        background-color: $card-border-color;\n        border-radius: 30px;\n\n        &.active {\n          background-color: $secondary-color;\n        }\n      }\n    }\n\n    .arrowContainer {\n      display: flex;\n      gap: 1rem;\n      margin: 20px 0;\n\n      .arrowBtn {\n        height: 50px;\n        width: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid $card-border-color;\n        border-radius: 10px;\n        cursor: pointer;\n        transition: 0.5s ease-in-out;\n\n        &:hover {\n          background-color: $secondary-color;\n          border: 1px solid transparent;\n          color: $white-color;\n        }\n      }\n    }\n  }\n}\n","// _variables.scss\n\n$primary-color: #ffbc51;\n$primary-dark-color: #d99221;\n$secondary-color: #015d8e;\n$secondary-dark-color: #0b4b6d;\n$white-color: #ffffff;\n$black-color: #212121;\n$black-dark-color: #000000;\n$card-border-color: #e3ebf2;\n$input-background-color: #fafafa;\n\n$border-radius: 8px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Testimonial": `Testimonial_Testimonial__yq7mr`,
	"cardContainer": `Testimonial_cardContainer__5NWoC`,
	"card": `Testimonial_card__YkUOl`,
	"cardFooterContent": `Testimonial_cardFooterContent__z5Hb8`,
	"Footer": `Testimonial_Footer__Phhvp`,
	"bulletContainer": `Testimonial_bulletContainer__5wibV`,
	"bullet": `Testimonial_bullet__XQ+9u`,
	"active": `Testimonial_active__blcgg`,
	"arrowContainer": `Testimonial_arrowContainer__5Kmi9`,
	"arrowBtn": `Testimonial_arrowBtn__p3scp`
};
export default ___CSS_LOADER_EXPORT___;
